/**
 * Yvine Design — product recommendations (fetched grid).
 * Cached asset, initialised once per [data-art="recommendations"] element by art-core.js
 * (first paint, every in-place page swap, theme-editor reloads).
 */
Art.section('recommendations', function (root) {
      var host = root;
      var grid = host.querySelector('[data-recs-grid]');
      var url = host.getAttribute('data-recs-url');
      // Already rendered server-side (or nothing to do)? Skip the fetch.
      if (!grid || !url || grid.children.length) return;
      fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recs-grid]');
          if (!fresh || !fresh.children.length) { host.hidden = true; return; }
          grid.innerHTML = fresh.innerHTML;
          grid.querySelectorAll('.scroll-reveal').forEach(function (el) { el.classList.add('is-visible'); });
          // Let art-card.js bind hover-video on the freshly injected cards.
          document.dispatchEvent(new Event('shopify:section:load'));
        })
        .catch(function () {});
    
});
